import React from 'react';

function Bar({ label, value, max, sublabel, thresholds = [70, 90] }) {
  const pct = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  const color =
    pct >= thresholds[1] ? '#ef4444' :
    pct >= thresholds[0] ? '#eab308' :
    '#6366f1';

  return (
    <div style={{ marginBottom: 18 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, alignItems: 'baseline' }}>
        <span style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 600 }}>{label}</span>
        <span style={{ fontSize: 12, color: pct >= thresholds[1] ? '#ef4444' : 'var(--text)', fontWeight: 700 }}>
          {sublabel}
        </span>
      </div>
      <div style={{ height: 7, background: 'var(--border)', borderRadius: 99, overflow: 'hidden' }}>
        <div style={{
          height: '100%',
          width: `${pct}%`,
          background: color,
          borderRadius: 99,
          transition: 'width 0.5s ease, background 0.3s ease',
        }} />
      </div>
    </div>
  );
}

export default function RiskMeter({ stats, onKillSwitch, confirmKill, onCancelKill }) {
  if (!stats) return null;

  const pnl          = stats.daily_pnl || 0;
  const maxLoss      = stats.max_daily_loss || 5000;
  const tradeCount   = stats.trade_count || 0;
  const maxTrades    = stats.max_trades_per_day || 20;
  const killActive   = stats.is_kill_switch_active;

  const lossUsed     = Math.max(0, -pnl);
  const lossLabel    = `₹${lossUsed.toLocaleString('en-IN', { maximumFractionDigits: 0 })} / ₹${maxLoss.toLocaleString('en-IN')}`;

  return (
    <div className="card">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
        <div style={{ fontWeight: 600 }}>Risk Meter</div>
        {killActive && (
          <span style={{
            fontSize: 11, fontWeight: 700, color: '#ef4444',
            background: 'rgba(239,68,68,0.12)',
            border: '1px solid rgba(239,68,68,0.3)',
            borderRadius: 99, padding: '2px 9px',
          }}>
            🛑 KILL SWITCH ON
          </span>
        )}
      </div>

      <Bar
        label="Daily Loss Buffer"
        value={lossUsed}
        max={maxLoss}
        sublabel={lossLabel}
      />
      <Bar
        label="Trades Used Today"
        value={tradeCount}
        max={maxTrades}
        sublabel={`${tradeCount} / ${maxTrades}`}
      />

      {/* Kill switch button */}
      <div style={{ borderTop: '1px solid var(--border)', paddingTop: 14, marginTop: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
        <div style={{ color: 'var(--muted)', fontSize: 11 }}>
          Max loss: ₹{maxLoss.toLocaleString('en-IN')}/day
        </div>
        <button
          className={`kill-switch-btn ${killActive ? 'active' : 'inactive'}`}
          onClick={onKillSwitch}
          style={{ width: '100%' }}
        >
          {confirmKill ? 'Confirm?' : killActive ? '🛑 ACTIVE' : '⬛ Arm Switch'}
        </button>
        {confirmKill && (
          <button className="btn btn-ghost" style={{ fontSize: 12, width: '100%' }} onClick={onCancelKill}>
            Cancel
          </button>
        )}
      </div>
    </div>
  );
}
